/*
 * @author: wayou
 * @date: 2018-08-28 18:01:12
 * @description: 顶部导航 - 左侧商标
 */

import './topBarLogo.scss';

import React, { Component } from 'react';
import { isInMobile } from '@umu/umu-ua';
import { $location } from '@umu/umu-dom';
import { services, components } from 'common';
const { Logo } = components;
const { getModuleData } = services;


type PropsType = {
    customizedLogo?: string
}

/** 是否是企业微信 */
function isWechatWork() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('wxwork');
}

/** 是否是钉钉 */
function isDingTalk() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('dingtalk');
}

/** 是否是飞书 */
function isFeishu() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('feishu') || ua.includes('lark');
}

export default class TopBarLogo extends Component<PropsType> {
    public onLogoClick = () => {
        // 手机或者企业微信客户端、钉钉客户端、飞书客户端打开PC页，重定向到m站点域名」
        const isRequestAlwaysUseMobile: boolean = isInMobile() || isFeishu() || isDingTalk() || isWechatWork();
        if (isRequestAlwaysUseMobile) {
            $location.href = '/index';

        } else {
            // pc跳pc的首页
            const host = getModuleData('siteHost');
            location.href = '//' + host + '/index';
        }
    };

    public render() {
        return (
            <div className="top-bar-logo" onClick={this.onLogoClick}>
                <Logo customizedLogo={this.props.customizedLogo} />
            </div>
        );
    }
}
